import { SxProps } from '@mui/material'

import theme from '../../shared/styles/themes/default.theme'

const styles = {
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-5),
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-3),
      width: `calc(100% + ${theme.spacing(3)} + ${theme.spacing(3)})`
    }
  } as SxProps,

  contentArea: {
    display: 'flex',
    gap: theme.spacing(3),
    padding: theme.spacing(4, 6),
    width: '100%',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: theme.spacing(2),
      gap: theme.spacing(1.5)
    }
  } as SxProps,

  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    width: 380,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  } as SxProps,

  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  } as SxProps,

  demoSection: {
    padding: theme.spacing(4, 6),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2)
    }
  } as SxProps,

  demoTitle: {
    marginBottom: theme.spacing(0.5)
  } as SxProps,

  demoSubtitle: {
    marginBottom: theme.spacing(2)
  } as SxProps
}

export default styles
